export const FRIEND_REQUEST_RECEIVED = '1';
export const FRIEND_REQUEST_ACCEPTED = '2';
export const FRIEND_REQUEST_REMINDER = '3';
export const JOURNEY_INVITE_RECEIVED = '4';
